import {format} from 'date-fns';

import {CalendarDay} from './teamCalendar';

export type CalendarDayTooltipTarget = 'pto' | 'birthday' | 'anniversary' | 'mixed';

/** Stable per-day key for deduping tooltip impressions within a dashboard visit. */
export const calendarDayTooltipDayKey = (day: CalendarDay): string =>
  format(day.date, 'yyyy-MM-dd');

export const calendarDayTooltipTarget = (day: CalendarDay): CalendarDayTooltipTarget => {
  const hasPto = day.isOut && day.people.length > 0;
  const hasBirthday = day.birthdays.length > 0;
  const hasAnniversary = day.anniversaries.length > 0;
  const kindCount = [hasPto, hasBirthday, hasAnniversary].filter(Boolean).length;

  if (kindCount > 1) {
    return 'mixed';
  }
  if (hasPto) {
    return 'pto';
  }
  if (hasBirthday) {
    return 'birthday';
  }
  if (hasAnniversary) {
    return 'anniversary';
  }
  return 'mixed';
};

export const calendarDayTooltipPersonCount = (day: CalendarDay): number =>
  day.people.length + day.birthdays.length + day.anniversaries.length;
